import type { ContactFieldDto } from '@carbonwebmail/contracts'

/**
 * What each kind of field is called on screen, and the order it is offered in.
 *
 * Two screens offer the picker — the Fields tab and the `+` past the last
 * column — and a second copy of this list is a second answer to what a kind is
 * called. The order is most-reached-for first rather than alphabetical, because
 * a picker is scanned from the top.
 *
 * `email`, `phone` and `url` are stored and compared exactly as text. The
 * difference is that a board can make them a link and a form can ask for them
 * properly, and nothing here says they are validated, because nothing validates
 * them.
 */

export const FIELD_KINDS: readonly (readonly [ContactFieldDto['type'], string])[] = [
  ['text', 'Text'],
  ['status', 'Status'],
  ['dropdown', 'Dropdown'],
  ['date', 'Date'],
  ['number', 'Number'],
  ['boolean', 'Yes / no'],
  ['email', 'Email address'],
  ['phone', 'Phone number'],
  ['url', 'Link'],
]

/** What one kind is called, for a table cell that shows it back. */
export function kindNamed(type: ContactFieldDto['type']): string {
  return FIELD_KINDS.find(([kind]) => kind === type)?.[1] ?? type
}
